import axios from "axios";
import API_BASE from "../config";

const api = axios.create({
  baseURL: API_BASE,
});

// Attach auth token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qq_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("qq_token");
      localStorage.removeItem("qq_agent");
      if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
